import { Formik, FormikErrors } from 'formik';
import { FormValues } from '@ahmdigital/form-validation/lib/validators/types';
import { ReactElement, useState } from 'react';

import { EmbeddedWidgetProvider } from './hooks/embedded-widget-context';
import {
  GetData,
  ModalField,
  PackagedSchema,
  SessionStorageKeys,
  StepInputAppearance,
  SubmitButtonConfig,
  WidgetBehavior,
  WidgetButtonSpacing,
} from './types';
import { SectionOfferStrip } from '../../pages/insurance/types';
import { WidgetId } from './constants';
import WidgetBody from './components/widget-body';

export type Title = {
  DESKTOP: string;
  MOBILE: string;
  MOBILE_SUBTITLE: string;
};

type EmbeddedWidgetProps = {
  behavior?: WidgetBehavior;
  buttonSpacing?: WidgetButtonSpacing;
  fluidWidth?: boolean;
  getData: GetData;
  getCustomParamValues?: () => Record<string, any>;
  getSchema: (errors: FormikErrors<FormValues>) => { packagedSchema: PackagedSchema };
  handleSubmit: (values: FormValues) => void;
  isDestinationPage?: boolean;
  isWidgetActive: boolean;
  modalFields: ModalField[];
  offer?: SectionOfferStrip;
  sessionStorageKeys?: SessionStorageKeys;
  setIsWidgetActive: (value: boolean) => void;
  stepInputAppearance?: StepInputAppearance;
  submitButton?: SubmitButtonConfig;
  title: Title;
  topField?: ReactElement;
  wrapperPadding?: string;
  widgetId: WidgetId;
  showFieldsRequiredLabel?: boolean;
};

const EmbeddedWidget = ({
  behavior,
  buttonSpacing,
  fluidWidth,
  getData,
  getCustomParamValues,
  handleSubmit,
  isDestinationPage,
  isWidgetActive,
  modalFields,
  offer,
  getSchema,
  sessionStorageKeys,
  submitButton,
  setIsWidgetActive,
  stepInputAppearance,
  title,
  topField,
  wrapperPadding,
  widgetId,
  showFieldsRequiredLabel,
}: EmbeddedWidgetProps) => {
  const [currentWidgetErrors, setCurrentWidgetErrors] = useState<FormikErrors<FormValues>>({});
  const { packagedSchema } = getSchema(currentWidgetErrors);

  return (
    <EmbeddedWidgetProvider
      behavior={behavior}
      currentWidgetErrors={currentWidgetErrors}
      getCustomParamValues={getCustomParamValues}
      sessionStorageKeys={sessionStorageKeys}
      setCurrentWidgetErrors={setCurrentWidgetErrors}
      modalFields={modalFields}
      widgetId={widgetId}
      showFieldsRequiredLabel={showFieldsRequiredLabel}
    >
      <Formik {...packagedSchema} onSubmit={handleSubmit}>
        <WidgetBody
          buttonSpacing={buttonSpacing}
          fluidWidth={fluidWidth}
          getData={getData}
          isWidgetActive={isWidgetActive}
          offer={offer}
          setIsWidgetActive={setIsWidgetActive}
          isDestinationPage={isDestinationPage}
          stepInputAppearance={stepInputAppearance}
          submitButton={submitButton}
          title={title}
          topField={topField}
          wrapperPadding={wrapperPadding}
          showFieldsRequiredLabel={showFieldsRequiredLabel}
        />
      </Formik>
    </EmbeddedWidgetProvider>
  );
};

export default EmbeddedWidget;
